export default "__VITE_ASSET__a8264a3d__"